export async function augmentTokenPrivy(tokenConfig, opts) {
    if (!opts.sendTransaction)
        throw new Error("missing required sendTransaction function - add sendTransaction from the usePrivy hook to the wallet object");
    const sendTransaction = opts.sendTransaction;
    tokenConfig.sendTx = async (data) => sendTransaction({
        ...data,
        gasLimit: data.gasLimit.toHexString(),
        maxFeePerGas: data.maxFeePerGas.toHexString(),
        maxPriorityFeePerGas: data.maxPriorityFeePerGas.toHexString(),
    }).then((r) => r.transactionHash);
}
//# sourceMappingURL=privy.js.map